import { RingSizes } from 'content/products/ring/productMap/constants';
import { RingProColors } from 'content/products/ring-pro';
import { ringProOpsSkuCode } from 'content/products/ring-pro/shipByConfig';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { BEST_BUY_PICKUP_ENABLED } from 'utils/featureFlags';
import { getPickupCatalogue } from './pickupCatalogue';
import { catalogueLists } from './pickupCatalogueRule';

/** Whether Best Buy stocks this color in this size: true only when the
 * backend catalogue is ready, the API says pickup is on, and it lists this
 * exact ops SKU. While it is idle or loading, after an error, with pickup off
 * or with the catalogue flag off, it is false. Not reactive on its own:
 * components call usePickupCatalogue() to re-render when it lands. */
export const pickupAvailableFor = (
  color: RingProColors,
  size: RingSizes,
): boolean =>
  catalogueLists(getPickupCatalogue(), ringProOpsSkuCode(color, size));

/** The ops SKU a pickup order for this selection would ask Best Buy for, or
 * null when pickup does not apply: flag off, not the US store, engraving, no
 * size yet, the sizing kit (open size), or a color and size the catalogue
 * doesn't list (including while it is not ready). Mirrors the homepage check. */
export const pickupSkuFor = (args: {
  store: string | null | undefined;
  color: RingProColors | null;
  size: RingSizes | null;
  engraving: boolean;
}): string | null => {
  if (!BEST_BUY_PICKUP_ENABLED) return null;
  const { store, color, size, engraving } = args;
  if (
    store !== ShopifyStore.US ||
    engraving ||
    color === null ||
    size === null ||
    size === RingSizes.OPEN ||
    !pickupAvailableFor(color, size)
  ) {
    return null;
  }
  return ringProOpsSkuCode(color, size);
};
